<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-field v-model="inputForm.settlementDate" label="结算日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.settlementTypeLabel" label="结算事项" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractCode" label="合同编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractPartyYiName" label="合同乙方" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractName" label="合同名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.feeAmount" :formatter="formatter" label="应付金额" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.settlementAmount" :formatter="formatter" label="结算金额" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <b-table class="bgc-dark" small head-variant="dark" responsive bordered
               :items="inputForm.feeDetailDTOList" :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template v-slot:cell(businessCode)="data">
          <div style="color: #4caedc" @click="showDetail(data.item.businessCode)">{{ data.item.businessCode }}</div>
        </template>

        <template v-slot:cell(businessAmount)="data">
          <div>{{ Number(data.item.businessAmount).toFixed(2) }}</div>
        </template>

        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.width }"
          >
        </template>
      </b-table>
      <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
        <p style="color: #AAA">附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from '@/api/system/queryInfoService'
export default {
  name: "ItsContractFeeSettlement",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_contract_fee_settlement',
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'businessCode', label: '单据号', width: '120px'},
        {key: 'businessDate', label: '费用发生日期', width: '120px'},
        {key: 'businessAmount', label: '金额（元）', width: '150px'},
      ]
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/contract/itsContractFeeSettlement/queryById').then(({ data }) => {
        this.inputForm = data
        if(!data.attachIds) {
          this.inputForm.attachList = []
        }
        this.getDict([
          ['its_settlement_type', 'settlementType'],
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    // 数据字典获取
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>

</style>